(() => {
class ComponentCartQuantity {
  constructor(container) {
    this.container = container;
    this.init();
  }

  init() {
    this.handleQuantityChange();
  }

  handleQuantityChange() {
    const qtyInput = this.container.querySelector(".component-cart-qty");
    const increaseButton = this.container.querySelector(".component-cart-plus");
    const decreaseButton = this.container.querySelector(".component-cart-minus");
    const cartForm = this.container.closest("form.cart-items"); 

    increaseButton.addEventListener("click", () => {
      const currentQty = Number.parseInt(qtyInput.value, 10);
      const increment = Number.parseInt(increaseButton.dataset.quantityChange, 10) || 1;
      const maximum = qtyInput.max ? Number.parseInt(qtyInput.max, 10) : Number.POSITIVE_INFINITY;
      qtyInput.value = Math.min(maximum, currentQty + increment);
      this.submitForm(cartForm);
    });

    decreaseButton.addEventListener("click", () => {
      const currentQty = Number.parseInt(qtyInput.value, 10);
      const decrement = Math.abs(Number.parseInt(decreaseButton.dataset.quantityChange, 10) || -1);
      const minimum = Number.parseInt(qtyInput.min, 10) || 1;
      if (currentQty > minimum) {
        qtyInput.value = Math.max(minimum, currentQty - decrement);
        this.submitForm(cartForm); 
      }
    });

    qtyInput.addEventListener("change", () => {
      const minimum = Number.parseInt(qtyInput.min, 10) || 1;
      const maximum = qtyInput.max ? Number.parseInt(qtyInput.max, 10) : Number.POSITIVE_INFINITY;
      const increment = Number.parseInt(qtyInput.step, 10) || 1;
      const requestedQuantity = Number.parseInt(qtyInput.value, 10) || minimum;
      const normalizedQuantity = minimum + Math.round((requestedQuantity - minimum) / increment) * increment;
      qtyInput.value = Math.min(maximum, Math.max(minimum, normalizedQuantity));
      this.submitForm(cartForm);
    });
  }

  submitForm(form) {
    if (form) {
      form.submit();
    }
  }

}

const initComponentCart = (scope = document) => {
  scope.querySelectorAll('.js-qty-wrap').forEach((container) => {
    if (container.dataset.quantityInitialized === 'true') return;

    container.dataset.quantityInitialized = 'true';
    new ComponentCartQuantity(container);
  });
};

window.initComponentCart = initComponentCart;
initComponentCart();

if (!window.componentCartLifecycleBound) {
  document.addEventListener('shopify:section:load', (event) => {
    window.initComponentCart?.(event.target);
  });
  window.componentCartLifecycleBound = true;
}
})();
